/* Keep the app's fixed WhatsApp launcher above the measured purchase bar. */
(function () {
  var adjusted = new Map();
  var pending = false;
  var selector = 'a[href*="wa.me"],a[href*="whatsapp"],[class*="whatsapp" i],[id*="whatsapp" i],iframe[src*="whats" i],[aria-label*="whatsapp" i]';
  function restore() {
    adjusted.forEach(function (values, el) {
      values.forEach(function (value, key) {
        if (value[0]) el.style.setProperty(key, value[0], value[1]);
        else el.style.removeProperty(key);
      });
    });
    adjusted.clear();
  }
  function layout() {
    pending = false;
    var bar = document.querySelector('[data-mobile-sticky-buy-bar]');
    if (!bar) return;
    var visible = innerWidth <= 768 && getComputedStyle(bar).display !== 'none';
    document.body.classList.toggle('sw-sticky-visible', visible);
    if (!visible) { restore(); return; }
    var preview = document.querySelector('#preview-bar-iframe, #shopify-preview-bar-iframe');
    var previewHeight = preview ? Math.max(0, innerHeight - preview.getBoundingClientRect().top) : 0;
    bar.style.setProperty('--sw-preview-offset', Math.min(previewHeight, 100) + 'px');
    var rect = bar.getBoundingClientRect();
    var space = (innerHeight - rect.top + 14) + 'px';
    if (document.body.style.getPropertyValue('--sw-bottom-space') !== space) document.body.style.setProperty('--sw-bottom-space', space);
    var targets = new Set();
    document.querySelectorAll(selector).forEach(function (el) {
      for (var parent = el; parent && parent !== document.body; parent = parent.parentElement) {
        var box = parent.getBoundingClientRect();
        if (getComputedStyle(parent).position === 'fixed' && box.width <= 160 && box.height <= 160 && box.width > 0) {
          targets.add(parent);
        }
      }
    });
    targets.forEach(function (el) {
      if (!adjusted.has(el)) {
        var values = new Map();
        ['bottom','top'].forEach(function (key) { values.set(key, [el.style.getPropertyValue(key), el.style.getPropertyPriority(key)]); });
        adjusted.set(el, values);
      }
      var bottom = Math.ceil(innerHeight - rect.top + 14) + 'px';
      if (el.style.bottom !== bottom) el.style.setProperty('bottom', bottom, 'important');
      if (el.style.top !== 'auto') el.style.setProperty('top', 'auto', 'important');
    });
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(layout); } }
  function init() {
    schedule();
    new MutationObserver(function (records) {
      if (records.some(function (r) { return r.type === 'childList' || !r.target.closest('[data-mobile-sticky-buy-bar]'); })) schedule();
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class','style']});
    new MutationObserver(schedule).observe(document.documentElement, {attributes: true, attributeFilter: ['class']});
    var bar = document.querySelector('[data-mobile-sticky-buy-bar]');
    if (bar && window.ResizeObserver) new ResizeObserver(schedule).observe(bar);
  }
  window.addEventListener('resize', schedule);
  window.addEventListener('scroll', schedule, {passive: true});
  if (window.visualViewport) { visualViewport.addEventListener('resize', schedule); visualViewport.addEventListener('scroll', schedule); }
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
